export const UNAVAILABLE_CODES = Object.freeze({
  NO_OPTIONS: "NO-OPTIONS",
  NO_INTERSECTING_OPTIONS: "NO-INTERSECTING-OPTIONS",
  PRODUCT_NOT_FOUND: "PRODUCT-NOT-FOUND",
  ZIP_CODE_NOT_FOUND: "ZIP-NOT-FOUND",
  ZIP_CODE_UNAVAILABLE: "ZIP-UNAVAILABLE",
  PRODUCT_UNAVAILABLE: "PRODUCT-UNAVAILABLE",
  STATE_ALCOHOL_RESTRICTION: "ALCOHOL-RESTRICTION",
  PRODUCT_ZIP_CODE_UNAVAILABLE: "PROD-ZIP-NA",
  FLORIST_UNAVAILABLE: "FLOR-NA",
  GIFT_BASKET_UNAVAILABLE: "GB-NA",
  TREE_UNAVAILABLE: "TREE-NA",
  DROPSHIP_UNAVAILABLE: "DS-NA",
  BALLOON_UNAVAILABLE: "BALLOON-NA",

  DATE_UNAVAILABLE: {
    CUTOFF_PAST: "CUTOFF",
    DAY_OF_WEEK_UNAVAILABLE: "DOW-UNAVAILABLE",
    HOLIDAY_ZIP_CODE: "HOLIDAY-ZIP-UNAVAILABLE-DATE",
    HOLIDAY_PRODUCT: "HOLIDAY-PRODUCT-UNAVAILABLE-DATE",
    HOLIDAY_DELIVERY_METHOD: "HOLIDAY-DELIVERY-METHOD-UNAVAILABLE-DATE",
    ZIP_CODE: "ZIP-UNAVAILABLE-DATE",
    PRODUCT: "PRODUCT-UNAVAILABLE-DATE",
    DELIVERY_METHOD: "DELIVERY-METHOD-UNAVAILABLE-DATE",
    DELIVERY_METHOD_EXPEDITED: "DELIVERY-METHOD-EXPEDITED-UNAVAILABLE-DATE",
    UPS: "UPS-UNAVAILABLE-DATE",
  },
});

export const UNAVAILABLE_MESSAGE_CODES = Object.freeze({
  [UNAVAILABLE_CODES.NO_OPTIONS]: "noOptions",
  [UNAVAILABLE_CODES.PRODUCT_NOT_FOUND]: "productNotFound",
  [UNAVAILABLE_CODES.ZIP_CODE_NOT_FOUND]: "zipCodeNotFound",
  [UNAVAILABLE_CODES.ZIP_CODE_UNAVAILABLE]: "zipCodeUnavailable",
  [UNAVAILABLE_CODES.PRODUCT_UNAVAILABLE]: "productUnavailable",
  [UNAVAILABLE_CODES.STATE_ALCOHOL_RESTRICTION]: "stateAlcoholRestriction",
  [UNAVAILABLE_CODES.PRODUCT_ZIP_CODE_UNAVAILABLE]: "productZipCodeUnavailable",

  // This is the default message when a multi-sku response is unavailable
  // Integrating sites will need to dig into the individual SKUs to determine
  // the best messaging.
  [UNAVAILABLE_CODES.NO_INTERSECTING_OPTIONS]: "noIntersectingOptions",

  // These may someday have configurable alternative URLS and be unique,
  // but for now we will unify their language in the UI output since we can't guess at URLs
  [UNAVAILABLE_CODES.FLORIST_UNAVAILABLE]: "zipCodeUnavailableSpecial",
  [UNAVAILABLE_CODES.GIFT_BASKET_UNAVAILABLE]: "zipCodeUnavailableSpecial",
  [UNAVAILABLE_CODES.TREE_UNAVAILABLE]: "zipCodeUnavailableSpecial",
  [UNAVAILABLE_CODES.DROPSHIP_UNAVAILABLE]: "zipCodeUnavailableSpecial",
  [UNAVAILABLE_CODES.BALLOON_UNAVAILABLE]: "zipCodeUnavailableSpecial",
});

export const ERROR_CODES = Object.freeze({
  REQUIRED_PARAMS_MISSING: "requiredParamsMissing",
  SERVER_ERROR: "serverError",
  ZIP_CODE_BLANK: "zipCodeBlank",
});